"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _react = _interopRequireWildcard(require("react"));
var _automationHooks = require("@airportlabs/automation-hooks");
var _Box = _interopRequireDefault(require("../Containers/Box"));
var _GhostButton = _interopRequireDefault(require("../Buttons/GhostButton"));
var _Text = _interopRequireDefault(require("../Typography/Text"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var propTypes = {
  /** Rendered page index */
  pageIndex: _propTypes["default"].number.isRequired,
  /** The total amount of pages available in the table based on the current pageSize value */
  pageCount: _propTypes["default"].number,
  /** Can navigate to next page (false if the last page is rendered) */
  canNextPage: _propTypes["default"].bool.isRequired,
  /** Can navigate to prev page (false if the first page is rendered) */
  canPreviousPage: _propTypes["default"].bool.isRequired,
  /** Change page using this method */
  gotoPage: _propTypes["default"].func.isRequired,
  /** Hook used for automation testing */
  automationHook: _propTypes["default"].string
};
var buttonSize = "22px";
var PaginationButton = (0, _styledComponents["default"])(_GhostButton["default"]).attrs(function (props) {
  return {
    color: "textSecondary",
    pV: "none"
  };
}).withConfig({
  displayName: "Pagination__PaginationButton",
  componentId: "sc-7j48zf-0"
})(["width:", ";height:", ";line-height:1;"], buttonSize, buttonSize);
var PaginationCurrent = _styledComponents["default"].div.withConfig({
  displayName: "Pagination__PaginationCurrent",
  componentId: "sc-7j48zf-1"
})(["padding:0;width:", ";height:", ";line-height:", ";border-radius:50%;background-color:", ";color:", ";text-align:center;"], buttonSize, buttonSize, buttonSize, function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.colors.textInverted;
});
var getPaginationStructure = function getPaginationStructure(currentPageIndex, totalPages) {
  if (totalPages <= 5) {
    // show all pages
    var pages = [];
    for (var i = 1; i <= totalPages; i++) {
      pages.push(i);
    }
    return pages;
  } else {
    // some pages will be hidden
    if (currentPageIndex < 3) {
      // a continuous array at the beginning
      return [1, 2, 3, 4, "dots", totalPages];
    } else if (currentPageIndex + 3 >= totalPages) {
      // a continuous array at the end
      return [1, "dots", totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
    } else {
      // an interrupted array at the beginning and the end
      // e.g. for index 3 and a total of 7 pages show
      // 1 ... 3 [4] 5 ... 7
      return [1, "dots", currentPageIndex, currentPageIndex + 1, currentPageIndex + 2, "dots", totalPages];
    }
  }
};
var Pagination = function Pagination(_ref) {
  var pageIndex = _ref.pageIndex,
    pageCount = _ref.pageCount,
    canNextPage = _ref.canNextPage,
    canPreviousPage = _ref.canPreviousPage,
    gotoPage = _ref.gotoPage,
    automationHook = _ref.automationHook;
  var _useState = (0, _react.useState)(getPaginationStructure(pageIndex, pageCount)),
    _useState2 = _slicedToArray(_useState, 2),
    paginationStructure = _useState2[0],
    setPaginationStructure = _useState2[1];
  (0, _react.useEffect)(function () {
    var visiblePagesNumbers = getPaginationStructure(pageIndex, pageCount);
    setPaginationStructure(visiblePagesNumbers);
  }, [pageIndex, pageCount]);
  return /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    gap: "base",
    p: "base",
    center: true
  }, /*#__PURE__*/_react["default"].createElement(_GhostButton["default"], {
    pV: "none",
    disabled: !canPreviousPage,
    onClick: function onClick() {
      return gotoPage(pageIndex - 1);
    },
    w: "auto",
    color: "text",
    automationHook: (0, _automationHooks.getHook)(automationHook, "previous")
  }, "Previous"), /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    d: "flex",
    alignItems: "center",
    gap: "xs"
  }, paginationStructure.map(function (item, index) {
    var NumberComponent = pageIndex === item - 1 ? PaginationCurrent : PaginationButton;
    return item === "dots" ? /*#__PURE__*/_react["default"].createElement(_Text["default"], _extends({
      key: index
    }, (0, _automationHooks.hook)(automationHook, "dots")), "...") : /*#__PURE__*/_react["default"].createElement(NumberComponent, _extends({
      key: index,
      onClick: function onClick() {
        return gotoPage(item - 1);
      }
    }, (0, _automationHooks.hook)(automationHook, "page-".concat(item))), item);
  })), /*#__PURE__*/_react["default"].createElement(_GhostButton["default"], {
    pV: "none",
    disabled: !canNextPage,
    onClick: function onClick() {
      return gotoPage(pageIndex + 1);
    },
    w: "auto",
    color: "text",
    automationHook: (0, _automationHooks.getHook)(automationHook, "next")
  }, "Next"));
};
Pagination.propTypes = propTypes;
var _default = Pagination;
exports["default"] = _default;